// api/axiosWrapper.js
import axios from "axios";
import { apiBaseUrl } from "environment";

const axiosRequest = axios.create({
    baseURL: apiBaseUrl,
});

export default axiosRequest;
